// extracted by mini-css-extract-plugin
export var grid = "_1x-0";
export var span1 = "_1x-2";
export var span10 = "_1x-b";
export var span10L = "_1x-z";
export var span10M = "_1x-n";
export var span10Xl = "_1x-1b";
export var span11 = "_1x-c";
export var span11L = "_1x-10";
export var span11M = "_1x-o";
export var span11Xl = "_1x-1c";
export var span12 = "_1x-d";
export var span12L = "_1x-11";
export var span12M = "_1x-p";
export var span12Xl = "_1x-1d";
export var span1L = "_1x-q";
export var span1M = "_1x-e";
export var span1Xl = "_1x-12";
export var span2 = "_1x-3";
export var span2L = "_1x-r";
export var span2M = "_1x-f";
export var span2Xl = "_1x-13";
export var span3 = "_1x-4";
export var span3L = "_1x-s";
export var span3M = "_1x-g";
export var span3Xl = "_1x-14";
export var span4 = "_1x-5";
export var span4L = "_1x-t";
export var span4M = "_1x-h";
export var span4Xl = "_1x-15";
export var span5 = "_1x-6";
export var span5L = "_1x-u";
export var span5M = "_1x-i";
export var span5Xl = "_1x-16";
export var span6 = "_1x-7";
export var span6L = "_1x-v";
export var span6M = "_1x-j";
export var span6Xl = "_1x-17";
export var span7 = "_1x-8";
export var span7L = "_1x-w";
export var span7M = "_1x-k";
export var span7Xl = "_1x-18";
export var span8 = "_1x-9";
export var span8L = "_1x-x";
export var span8M = "_1x-l";
export var span8Xl = "_1x-19";
export var span9 = "_1x-a";
export var span9L = "_1x-y";
export var span9M = "_1x-m";
export var span9Xl = "_1x-1a";
export var stretch = "_1x-1";